<script>
import BillBackDetail from '@/views/bill/components/BillBackDetail.vue';
import { API } from '@/net/http';
import BillStorageDetail from '@/views/bill/components/BillStorageDetail.vue';
import StripeBindCard from '@/components/stripe/StripeBindCard.vue';
import MkButton from '@/components/button/MkButton.vue';
import BillSendDetail from '@/views/bill/components/BillSendDetail.vue';
import BillAdjustmentDetail from '@/views/bill/components/BillAdjustmentDetail.vue';

export default {
  name: 'FailedBill',
  components: { BillAdjustmentDetail, BillSendDetail, MkButton, StripeBindCard, BillStorageDetail, BillBackDetail },
  data() {
    return {
      orderNum: this.$route.params.orderNumber,
      bindLoading: false,
      apiLoading: false,
      totalFee: 0,
      failedSendBills: [],
      failedStorageBills: [],
      failedBackBills: [],
      failedAdjustment: [],
    };
  },
  computed: {},
  mounted() {
    this.fetchFailedBills();
  },
  methods: {
    fetchFailedBills() {
      this.$post(API.billListFailed, this.orderNum).then(res => {
        if (!res.success) {
          if (res?.code === 'kite.common.order.no-pay-failed') {
            this.$router.push('/send/' + this.orderNum);
            return;
          }
          this.$Message.error({
            content: res.message,
            duration: 3,
          });
          return;
        }
        this.totalFee = res.data.totalFee;
        this.failedSendBills = res.data.sendList;
        this.failedStorageBills = res.data.storageList;
        this.failedBackBills = res.data.backList;
        this.failedAdjustment = res.data.adjustment;
      });
    },
    bind() {},
    onBindSuccess() {
      this.apiLoading = true;
      this.$post(API.billListPayFailed, this.orderNum)
        .then(res => {
          if (!res.success) {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
            return;
          }
          this.$router.push('/send/' + this.orderNum);
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },
  },
};
</script>

<template>
  <i-row :gutter="60">
    <i-col span="12">
      <p class="title">Change your payment method</p>
      <div style="position: relative">
        <stripe-bind-card ref="stripeBindCard" @change-loading="bindLoading = $event" @bind-success="onBindSuccess" />
        <div style="margin: 30px; text-align: center;">
          <mk-button type="primary" @click="$refs.stripeBindCard.confirmPayment(false)">
            Confirm and pay
          </mk-button>
        </div>
        <i-spin v-if="bindLoading || apiLoading" fix>
          <i-icon type="ios-loading" size="40" class="spin-icon-load" />
        </i-spin>
      </div>
    </i-col>
    <i-col span="11" :offset="1">
      <p class="title">Unpaid bills</p>
      <div v-for="(bill, index) in failedSendBills" :key="index">
        <BillSendDetail :info-send="bill" />
      </div>
      <div v-for="(bill, index) in failedStorageBills" :key="index">
        <BillStorageDetail :info-prepayment="bill" />
      </div>
      <div v-for="(bill, index) in failedBackBills" :key="index">
        <BillBackDetail :info-prepayment="bill" />
      </div>
      <div v-for="(bill, index) in failedAdjustment" :key="index">
        <BillAdjustmentDetail :info-prepayment="bill" />
      </div>
      <div class="total-fee">
        <div>Total</div>
        <div>${{ totalFee }}</div>
      </div>
    </i-col>
  </i-row>
</template>

<style lang="less" scoped>
@import '~@/assets/fonts/font.less';

.title {
  .font-medium;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 30px;
}
.total-fee {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;

  .font-medium;
  font-size: 18px;
  font-weight: 400;
}
</style>
